import React, { useState, ChangeEvent, forwardRef } from "react";
import clsx from "clsx";
import "./CommonInput.scss";

const CommonInput = forwardRef(
  (
    {
      label,
      style,
      displayMultiInput,
      hasMarginBottom,
      marginBottomValue,
      isError,
      setIsError,
      onChange,
      value,
      setValue,
      setFormData,
      className,
      defaultText,
      maxLength,
      errorText = "입력값이 양식에 맞지 않습니다.",
      onClick,
      ...props
    },
    ref
  ) => {
    const [helperText, setHelperText] = useState(defaultText);

    
    const handleChange = (e) => {
      const { name, value } = e.target;
      const copy = name === "tel"
        ? value.replace(/[^0-9]/g, "")
        : value;

      if (setFormData) {
        setFormData((prevData) => ({
          ...prevData,
          [name]: copy,
        }));
      }

      if (name === "email" && value !== "") {
        const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i;
        if (!emailPattern.test(copy)) {
          if (setIsError) {
            setIsError(true);
          }
          return setHelperText(errorText);
        }
      }

      if (name === "tel" && copy !== "") {
        const telPattern = /^0[0-9]{8,10}$/;
        if (!telPattern.test(copy)) {
          if (setIsError) {
            setIsError(true);
          }
          return setHelperText(errorText);
        }
      }

      if (setIsError) {
        setIsError(false);
      }
    };

    const inlineStyles = {
      ...style, // 추가적인 인라인 스타일을 덮어쓰기
    };

    const marginBottomStyle =
      hasMarginBottom || marginBottomValue !== undefined
        ? {
            marginBottom: `${
              isError ? "0.8rem" : marginBottomValue || "3.2rem"
            }`,
          }
        : {};

    return (
      <div
        ref={ref}
        className={clsx(
          "common-input__container",
          props.marginright ? `mr-${props.marginright}` : ""
        )}
        style={marginBottomStyle}
        onClick={onClick}
      >
        {label && <label className="common-input__label">{label}</label>}
        {displayMultiInput ? (
          <textarea
            className={clsx("common-textarea", "common-input__multy")}
            style={inlineStyles}
            value={value}
            onChange={handleChange}
            {...props}
          />
        ) : (
          <input
            className={clsx(
              "common-input",
              props.className,
              isError ? "common-input-error" : "common-input"
            )}
            style={inlineStyles}
            value={value}
            maxLength={maxLength}
            onChange={handleChange}
            {...props}
          />
        )}
        {isError && <div className="common-input-errorTxt">{helperText}</div>}
      </div>
    );
  }
);
export default CommonInput;
